import React from 'react';
import { Shield } from 'lucide-react';
import styles from '../../styles/institutional.module.css';

const SECTIONS = [
    {
        title: '1. Quais dados coletamos',
        content: null,
        list: [
            'Nome completo e endereço de e-mail (obrigatórios para criação de conta)',
            'Telefone e CNPJ (opcionais, utilizados nas notas de serviço)',
            'Endereço / localização (opcional, preenchido via ViaCEP)',
            'Dados das notas de serviço: clientes, valores, impostos e observações',
            'Foto de perfil (opcional, enviada pelo usuário)',
            'Dados de pagamento processados pelo Mercado Pago (não armazenamos dados de cartão)',
        ],
    },
    {
        title: '2. Como usamos seus dados',
        content: 'Utilizamos suas informações exclusivamente para operar e melhorar o Orçamento Digital. Nunca vendemos ou compartilhamos seus dados com terceiros para fins publicitários.',
        list: [
            'Autenticação e segurança da sua conta',
            'Geração e armazenamento de notas de serviço',
            'Processamento de pagamentos via Mercado Pago',
            'Backup automático dos seus documentos',
            'Envio de comunicações relacionadas ao serviço (sem spam)',
        ],
    },
    {
        title: '3. Armazenamento e segurança',
        content: 'Seus dados são armazenados no MongoDB Atlas com criptografia em repouso. As senhas são protegidas com hash bcrypt (salt 12). Toda comunicação entre cliente e servidor utiliza HTTPS/TLS.',
        list: null,
    },
    {
        title: '4. Compartilhamento de dados',
        content: null,
        list: [
            'Mercado Pago — processamento de pagamentos (sujeito à política de privacidade deles)',
            'MongoDB Atlas — infraestrutura de banco de dados',
            'Render.com — hospedagem do servidor e frontend',
            'Nenhum outro terceiro tem acesso aos seus dados',
        ],
    },
    {
        title: '5. Seus direitos (LGPD)',
        content: 'Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem os seguintes direitos:',
        list: [
            'Acesso: solicitar uma cópia de todos os seus dados',
            'Correção: atualizar dados incorretos ou incompletos',
            'Exclusão: solicitar a remoção de todos os seus dados',
            'Portabilidade: exportar seus dados em formato legível',
            'Revogação: retirar consentimentos dados anteriormente',
        ],
    },
    {
        title: '6. Cookies',
        content: 'O Orçamento Digital utiliza apenas o localStorage do navegador para armazenar o token de autenticação JWT. Não utilizamos cookies de rastreamento, analytics ou publicidade.',
        list: null,
    },
    {
        title: '7. Retenção de dados',
        content: 'Seus dados são mantidos enquanto sua conta estiver ativa. Ao solicitar a exclusão da conta, todos os seus dados pessoais e notas de serviço são removidos permanentemente em até 30 dias.',
        list: null,
    },
    {
        title: '8. Contato',
        content: 'Para exercer seus direitos ou tirar dúvidas sobre privacidade, entre em contato pelo e-mail: privacidade@notafacil.com.br. Respondemos em até 72 horas úteis.',
        list: null,
    },
];

export default function Privacidade() {
    return (
        <div className={styles.page}>
            <div className={styles.proseWrap}>

                {/* Header */}
                <div className={styles.proseHero}>
                    <div className={styles.proseBadge}>
                        <Shield size={11} style={{ display:'inline', marginRight:'4px', verticalAlign:'middle' }} />
                        Política de Privacidade
                    </div>
                    <h1 className={styles.proseTitle}>Como protegemos seus dados</h1>
                    <p className={styles.proseDate}>Última atualização: Janeiro de 2025 · Em conformidade com a LGPD</p>
                </div>

                {/* Destaque */}
                <div className={styles.proseBody}>
                    <p className={styles.proseHighlight}>
                        O Orçamento Digital foi construído com privacidade em mente. Coletamos apenas o mínimo necessário
                        para operar o serviço, nunca vendemos seus dados e você tem controle total sobre suas informações.
                    </p>

                    {SECTIONS.map((section, i) => (
                        <div key={i} className={styles.proseSection}>
                            <h2 className={styles.proseSectionTitle}>{section.title}</h2>
                            {section.content && (
                                <p className={styles.proseText}>{section.content}</p>
                            )}
                            {section.list && (
                                <ul className={styles.proseList}>
                                    {section.list.map((item, j) => (
                                        <li key={j}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}